import contract from '@mailobj-browser/front/js/contracts/contract.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import wait from '@mailobj-browser/front/js/utils/wait.js'
import { get } from '#utilities/js/ea/ajax.js'
import href from '#utilities/js/ea/href.js'
import * as utilities from '#utilities/js/styles.js'
import mbox from './mbox.js'
import parent from './parent.js'

export default contract({
  mbox: array([
    mbox
  ]),
  parent: array([
    parent
  ]),
})

export const init = async (wrapper) => {
  const url = href('mail/req_xfiles_getattach')
  let promise = get(url, { target: wrapper })
  const loader = one(`.${elements.loader}`, wrapper)

  queueMicrotask(async () => {
    await wait(1000)

    if (promise) {
      if (loader) {
        loader.classList.remove(utilities.modifiers.display.none)
      }
    }
  })

  await promise
  promise = null
  if (loader) {
    loader.classList.add(utilities.modifiers.display.none)
  }

  await get(url, { target: wrapper })
}